module.exports = __webpack_public_path__ + "img/logo_yellow.9bfb3794.svg";